export default __webpack_public_path__ + "static/media/GR4 2A-2C-2EC.48cf2516.jpg";